import React, { useState } from "react";
import clsx from 'clsx';
import { makeStyles, darken } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import ProgressDiagram from "./progress-diagram";
import { RECTANGLE_BLUE, RECTANGLE_VIOLET } from '../../utils/constants';
import FitnessCenterIcon from '@material-ui/icons/FitnessCenter';
import Typography from "@material-ui/core/Typography";
import useThemeQuery from '../../graphql/queries/toggle-theme';

  const diagram = [
    {  
      topicWidth: '35%',
      message: [
        {stops: RECTANGLE_BLUE, duration: 120, interval: 1, from: 'bot'},
        {stops: RECTANGLE_BLUE, duration: 90, interval: 2, from: 'user'},
        {stops: RECTANGLE_VIOLET, duration: 140, interval: 1.3, from: 'bot'},
        {stops: "#fff", duration: 80, y: 415, interval: 1.5, from: 'user'},
        {stops: RECTANGLE_BLUE, duration: 140, interval: 1.3, from: 'bot'},
      ]
    },
    {  
      topicWidth: '25%',
      type: 'form',
      message: [
        {stops: RECTANGLE_VIOLET, duration: 120, interval: 1.5, from: 'user'},
        {stops: RECTANGLE_VIOLET, duration: 120, interval: 1, from: 'bot'},
        {stops: RECTANGLE_VIOLET, duration: 100, interval: 0.5, from: 'bot'},
        {stops: RECTANGLE_VIOLET, duration: 80, interval: 0.5, from: 'bot'},
      ]
    },
    {  
      topicWidth: '25%',
      message: [
        {stops: RECTANGLE_BLUE, duration: 120, interval: 1, from: 'bot'},
        {stops: RECTANGLE_VIOLET, duration: 100, interval: 1.5, from: 'user'},
        {stops: RECTANGLE_VIOLET, duration: 80, interval: 1, from: 'bot'},
        {stops: RECTANGLE_VIOLET, duration: 60, interval: 1.5, from: 'user'},
        {stops: RECTANGLE_VIOLET, duration: 50, interval: 0.5, from: 'bot'},
      ]
    },
  ];
const useStyles = makeStyles({
    borderedContainer: {
      borderLeft: '2px solid #704da3',
      borderRight: '2px solid #704da3',
    },
    containerLight: {
      // borderTop: '2px solid #704da3',
      // borderBottom: '2px solid #704da3',
      backgroundColor: '#172947',
    },
    borderedContainerLight: {
      borderTop: '2px solid #704da3',
      borderBottom: '2px solid #704da3',
    },
    containerDark: {
        backgroundColor: '#F1EEF6',
    },
    noborder: {
      borderLeft: '2px solid transparent',
      borderRight: '2px solid transparent',
      borderTop: '2px solid transparent',
      borderBottom: '2px solid transparent',
    },
    label: {
      color: '#B3BEDA',
      textTransform: 'uppercase',
      fontSize: 14,
      fontWeight: 700
    },
    icon: {
        fontSize: 16,
        transform: 'rotate(90deg)'
    },
    iconLight: {
      color: '#A3B2D4',
    },
    iconDark: {
      color: '#B3C1E4',
    },
    text: {
      color: '#704da3',
      fontWeight: 600
    }
})

const DiagramContainer = props => {
  const classes = useStyles();
  const [ open, setOpen ] = useState(false);
  const { data } = useThemeQuery();

  const handleOpen = () => setOpen(!open);

  const text = (
    <Box mt={2} mr={1} height={25} position="relative" right={20}>
      <Typography className={classes.text}>Form</Typography>
    </Box>
  )

  return (
        <Box bgcolor={data && data.theme ? "#172947": "#fff"} borderRadius={20} borderColor="#f1c074" border={2} overflow="hidden" mb={2}>
            <Box display="flex">
                <Box display="flex" flexDirection="column">
                    <Box flexGrow={1} display="flex" alignItems={open ? "flex-end": "center"} justifyContent="center" px={2} pb={open? 1: 0}>
                        <Typography className={classes.label}>User</Typography>
                    </Box>
                    {data && data.theme && <Box bgcolor={darken("#4a5d77", 0.8)} height="1px"></Box>}
                    <Box flexGrow={1} display="flex" alignItems={open ? "flex-start": "center"} justifyContent="center" px={2} pt={open? 1: 0}>
                        <Typography className={classes.label}>Bot</Typography>
                    </Box>
                </Box>
                <Box display="flex" flexGrow={1} justifyContent="center" alignItems="flex-start">
                    <Box display="flex" flexGrow={1} alignItems="center" height={open ? 302: '100%'} py={open? 25: 0}>
                          { diagram.map(d => (
                            <Box
                              width={d.topicWidth}
                              display="flex"
                              className={d.type ? clsx(classes.borderedContainer, data && data.theme? classes.containerLight: classes.containerDark, d.type && open && classes.borderedContainerLight): classes.noborder}
                              height={open ? 305: 125}
                              flexGrow={1}
                              py={open ? 0: 1}
                              borderRadius={open ? 15: 1}
                            >
                                { d.message.map(m => <ProgressDiagram data={m} openIcon isBarChart={open}/>) }
                                { d.type && open && text}
                            </Box>
                        ))}
                      { data && data.theme && <Box bgcolor={darken("#4a5d77", 0.8)} height="1px" width="85.8%" position="absolute"></Box> }
                    </Box>

                    <Box>
                        <Box px={1} pt={1} mr={0.5} mt={1} bgcolor={data && data.theme ? "#203651": "#F5F6FA"} borderRadius={4} onClick={handleOpen}>
                            <FitnessCenterIcon className={clsx(classes.icon, data && data.theme ? classes.iconLight: classes.iconDark)}/>
                        </Box>  
                    </Box>
                </Box>
            </Box>
        </Box>
  );
};

export default DiagramContainer;